import { render, staticRenderFns } from "./UpdatePlanPrevention.vue?vue&type=template&id=7afa0228&scoped=true&"
import script from "./UpdatePlanPrevention.vue?vue&type=script&lang=ts&"
export * from "./UpdatePlanPrevention.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePlanPrevention.vue?vue&type=style&index=0&id=7afa0228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afa0228",
  null
  
)

export default component.exports